import axios from 'axios';

import interceptorService from '../services/interceptors/interceptor.service';

axios.interceptors.request.use(interceptorService.request);

axios.interceptors.response.use(interceptorService.response, (error) => {
  error = error || {};

  if (!error.response) {
    error.response = {};
  }

  // Check if request was cancelled by the user and set the status
  if (axios.isCancel(error)) {
    (error as any).response.status = -1;
    (error as any).response.config = {
      timeout: {
        _value: 'CANCELLED_REQUEST',
      },
    };
  }

  return interceptorService.responseError(error);
});
